import { useState } from 'react'
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Close from 'mdi-material-ui/Close'
import Dialog from '@mui/material/Dialog'
import Box from '@mui/material/Box';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

type ImageExpansionProps = {
    url: string;
    onClose: () => any;
    multiMediaType: string;   // multimedia could either be of type image or video
};

const MultimediaPreview = (props: ImageExpansionProps) => {
    const [open, setOpen] = useState<boolean>(false);

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Dialog open={true} onClose={props.onClose} BackdropComponent={Backdrop} BackdropProps={{ invisible: true }} fullWidth maxWidth="sm">
                <DialogTitle>Preview</DialogTitle>
                <DialogContent sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <IconButton size='small' onClick={props.onClose} sx={{ position: 'absolute', right: '1rem', top: '1rem' }}>
                        <Close />
                    </IconButton>
                    {
                        props.multiMediaType === 'image' &&
                        <img
                            srcSet={`${props.url}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                            src={`${props.url}?w=164&h=164&fit=crop&auto=format`}
                            alt=""
                            loading="lazy"
                            style={{
                                maxHeight: "100%",
                                maxWidth: "100%",
                                objectFit: "contain"
                            }}
                        />
                    }{props.multiMediaType === 'video' &&
                        <video width="100%" height="100%" controls>
                            <source src={props.url} />
                            Your browser does not support the video tag.
                        </video>
                    }
                </DialogContent>
            </Dialog>
        </>
    )
}

export default MultimediaPreview;
